import { api } from '../api/client'

/**
 * Кто вошёл — пользователь из токена доступа (поле sub), без запроса к серверу. null — не вошли; '' — токен не
 * прочитать (тогда сравнивать не с чем).
 *
 * Ожидания генераций без потолка (план «Ждём ответа нейросети») переживают выход из аккаунта и ждут входа. Войти в той
 * же вкладке может другой человек — его сессия не должна доводить и показывать чужие генерации (ревью 27.09).
 */
export function sessionUserId(): string | null {
	const token = api.getToken()
	if (!token) return null
	try {
		const part = token.split('.')[1] || ''
		const b64 = part.replace(/-/g, '+').replace(/_/g, '/')
		const payload = JSON.parse(atob(b64 + '='.repeat((4 - (b64.length % 4)) % 4))) as { sub?: unknown }
		return payload.sub != null ? String(payload.sub) : ''
	} catch {
		return ''
	}
}

/** Вошёл другой человек: оба известны и различаются. */
export function isOtherUser(owner: string | null, current: string | null): boolean {
	return !!owner && !!current && owner !== current
}
